<template>
    <div>
        <div class="d-flex flex-column p-3">

            <!-- Botones -->
            <div style="position: relative; z-index: 5">
                <div class="d-flex" style="position: absolute">
                    
                    <!-- Agregar -->
                    <agregar-cliente-terrestre-modal />

                    <!-- Editar -->
                    <editar-clientes-terrestres-modal 
                        :ids = "checks"
                    />
                    <editar-simple-clientes-terrestres-modal
                        :ids = "ids"
                    />


                    <Button
                        :size="15"
                        color="#E15361"
                        colorText="#ffffff"
                        tooltip="Editar proveedores seleccionados"
                        icon="far fa-trash-alt"
                        round
                        :width="30"
                        class="mr-2"
                        traslate
                        @click.native="deleteChecks"
                        :inactive="checks.length < 1"
                    />
                    
                    <!-- Filtros -->
                    <filtros-clientes-terrestres-modal />
                    
                    <Button 
                        class="mr-2" 
                        color="#E15361" 
                        colorText="#fff" 
                        icon="fas fa-filter" 
                        :width="30" 
                        tooltip="Recargar Tabla" 
                        @click.native="fetch"
                        round
                    />

                    <Button 
                        color="#4FB36A" 
                        colorText="#fff" 
                        icon="fas fa-file-excel" 
                        :width="30" 
                        tooltip="Generar Reporte Excel" 
                        round
                        @click.native="actionSetShowBtnExportFiltersClientGroundModal(true); actionSetShowModalFiltersClientGroundModal(true);"
                    />
                </div>
            </div>

            <Loading v-if="showLoadingClientGround" />

            <div v-else class="w-100 text-center">
                <new-data-table
                    :headers="headers"
                    :data="data"
                    :acciones="acciones"
                    :max="10"
                    paginacion
                    numerador
                    :seleccionar="obtenerFilaSeleccionada"
                    :filaChekeada="obtenerFilaSeleccionada"
                    check
                    idtabla="listado_clientes_terrestres_tabla"
                />
            </div>
            
                
        </div>
    </div>
</template>

<script>

    import { mapActions, mapState } from 'vuex';
    import Button from '../../common/Button.vue';

    import AgregarClienteTerrestreModal from '../../modals/tarifas/clientesTerrestres/AgregarClienteTerrestreModal.vue';
    import EditarClientesTerrestresModal from '../../modals/tarifas/clientesTerrestres/EditarClientesTerrestresModal.vue';
    
    import FiltrosClientesTerrestresModal from '../../modals/tarifas/clientesTerrestres/FiltrosClientesTerrestresModal.vue';
    import { tariffClientsGroundDelete, tariffClientsGroundIndex, tariffClientsGroundInit } from '../../../constants/serviciosLogisticos';
    import NewDataTable from '../../common/NewDataTable.vue';
    import Loading from '../../common/loading.vue';
    import EditarSimpleClientesTerrestresModal from '../../modals/tarifas/clientesTerrestres/EditarSimpleClientesTerrestresModal.vue';

    export default {

        data() {
            return {
                // Estructura para utilizar dataTable vue
                headers: ["ID", "Cliente", "Proveedor", "Desde", "Hasta", "Retiro/Entrega (Vacío)", "Planta/Bodega", "Entrega/Retiro (Full)" , "Extra Costo Tipo", "Tipo Contenedor", "Moneda", "Valor", "Observaciones" ,"ID Tarifa Proveedor","Acciones"],
                acciones: [],
                data: [],
                checks: [],
                ids : [],

            };
        },

        components: { Button, AgregarClienteTerrestreModal, EditarClientesTerrestresModal, FiltrosClientesTerrestresModal, NewDataTable ,Loading, EditarSimpleClientesTerrestresModal },

        computed: {
            ...mapState("serviciosLogisticos", [
                "dataTableClientGround",
                'showLoadingClientGround',
                "showModalEditClientGroundModal",
                "showModalEditSimpleClientGroundModal"
            ]),
        },
        methods : {

            ...mapActions("serviciosLogisticos", [
                "actionSetDataTableClientGround",
                "actionSetShowLoadingClientGround",
                "actionSetClientsList",
                "actionSetContainerTypes",
                "actionSetIntegralServiceType",
                "actionSetPortsList",
                "actionSetZonesList",
                "actionSetListCarriers",
                "actionSetListCurrencies",
                "actionSetShowModalEditSimpleClientGroundModal",
                "actionSetShowModalFiltersClientGroundModal",
                "actionSetShowBtnExportFiltersClientGroundModal",
                "actionSetGroundTariffsExtraCostType"
            ]),
            async init(){

                const { data } = await tariffClientsGroundInit() ;

                this.actionSetClientsList( data.clients );
                this.actionSetContainerTypes( data.containerTypes );
                this.actionSetIntegralServiceType( data.integralServiceTypes );
                this.actionSetIntegralServiceType( data.integralServiceTypes );
                this.actionSetPortsList( data.ports );
                this.actionSetZonesList( data.zones );
                this.actionSetListCarriers( data.carriers );
                this.actionSetListCurrencies( data.currencies );
                this.actionSetGroundTariffsExtraCostType( data.extraCostTypes );

            },
            async fetch(){
            
                this.actionSetShowLoadingClientGround( true );

                const { data } = await tariffClientsGroundIndex() ;

                this.actionSetDataTableClientGround( data ) ;

                this.actionSetShowLoadingClientGround( false );
            },
            async generarBotonesAcciones() {

                this.acciones = [];

                await this.data.map((item, index) => {

                    this.acciones.push([
                        {
                            icon: "fa fa-edit zoom ",
                            title: "Editar",
                            id: index,
                        },
                        {
                            icon: "fa fa-times text-danger zoom",
                            title: "Eliminar",
                            id: index,
                        },
                    ]);
                });
            },
            async deleteChecks(){

                const response = await this.$vToastify.prompt(`¿Desea eliminar ${ this.checks.length } Registros?`) ;

                if( ! response ) return ;

                this.$vToastify.loader("Eliminando...");

                try {
                    
                    const payload = {
                        ids : this.checks
                    };

                    await tariffClientsGroundDelete( payload ) ;

                    this.$vToastify.stopLoader();

                    this.$vToastify.success("Se han eliminado Registro(s)", "Éxito");

                    return this.fetch();

                } catch (error) {
                    this.$vToastify.stopLoader();                        
                    this.$vToastify.error("Hubo un problema al intentar eliminar. Favor, recargue la página y vuelva a intentar.", "Error");
                }

            },

            async obtenerFilaSeleccionada( { id , accion , estado } ){

                const idd = +this.data[ id ].data_complementaria.id ;

                
                switch (accion) {

                    case "Eliminar": {

                        const response = await this.$vToastify.prompt(`¿Desea eliminar Tarifa Cliente ID - ${idd}?`) ;

                        if( ! response ) return ;

                        this.$vToastify.loader("Eliminando...");

                        try {

                            const payload = { ids : [ idd ] } ;

                            await tariffClientsGroundDelete( payload ) ;

                            this.$vToastify.stopLoader();

                            this.$vToastify.success("Se ha eliminado Registro", "Éxito");

                            return this.fetch();

                        } catch (error) {

                            this.$vToastify.stopLoader();                        
                            this.$vToastify.error("Hubo un problema al intentar eliminar. Favor, recargue la página y vuelva a intentar.", "Error");
                        }

                    }
                    break;

                    case "Editar": {

                        this.actionSetShowModalEditSimpleClientGroundModal( true );

                        this.ids = [ idd ];
                    }
                    break;
                    case "fila_chekeada":{
                        estado 
                            ? this.checks.push( idd )
                            : this.checks = this.checks.filter( c => c != idd ) ;
                    }

                    break;
                    default:
                        break;
                }
                
            }
        },
        mounted() {
            this.init();
            this.fetch() ;
        },
        watch: {
            dataTableClientGround : function( _new ) {

                if( _new ){

                    this.checks = [];

                    this.data = _new.map( n => ({

                        data: [
                            n.id ,
                            n.name_client ,
                            n.name_carrier ,
                            n.from ,
                            n.to   ,
                            n.name_pol ,
                            n.name_plant,
                            n.name_pod ,
                            n.name_extra_cost_type ,
                            n.name_type_container ,
                            n.code_currency,
                            n.value,
                            n.comment,
                            n.id_tariff_provider_ground,
                        ],
                        data_complementaria : n
                    })) ;

                    this.generarBotonesAcciones() ;
                }
            },
            showModalEditSimpleClientGroundModal: function( _new ){
                
                !_new && (this.ids = []);
            }

        }
    }
</script>

<style>

</style>,
                